<template>
  <div id="choose-apply-address">
    <h2 class="f-14 font-bold c-6 p-b15">寄送方式</h2>
    <div class="area">
      <div class="area-head clearfix">
        <span class="c-hover f-18 font-bold">邮寄</span>
        <span class="m-l10 c-9 f-13">选择邮寄地址</span>
        <span class="c-hover f-13 fr pointer" @click="addAddress">
          <i class="el-icon-plus"></i>
          新增邮寄地址
        </span>
      </div>
      <div
        class="item"
        v-for="(cell, index) in data"
        :key="cell.id"
        @click="$emit('update:select', index)"
      >
        <el-radio class="radio" :value="select" :label="index">
          {{
            `${cell.recipientsName}; ${cell.recipientsPhone}; ${cell.province}/${cell.city}/${cell.area}/${cell.detailAddress}`
          }}
        </el-radio>
        <span v-if="select === index" class="c-hover f-13 fr" @click="editAddress(cell)">编辑</span>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="邮寄地址"
      width="480px"
      @open="handleDialogOpen"
    >
      <el-form :model="selecteAddress" inline label-width="80px" style="width:420px;margin:0 auto;">
        <el-form-item required label="收件人">
          <el-input
            style="width:300px"
            v-model.trim="selecteAddress.recipientsName"
            placeholder="请输入收件人"
          ></el-input>
        </el-form-item>
        <el-form-item required label="手机号">
          <el-input
            style="width:300px"
            :value="selecteAddress.recipientsPhone"
            @input="handleInputPhone"
            maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item required label="地址信息">
          <el-cascader
            v-if="dialogVisible"
            ref="elCascader"
            style="width:300px"
            popper-class="choose-apply-address-dia"
            placeholder="请选择地址"
            v-model="selecteAddress.address"
            :options="addressOptions"
            @expand-change="handleExpandChange"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item required label="详细地址">
          <el-input
            style="width:300px"
            v-model.trim="selecteAddress.detailAddress"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddress">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post, get } from '@/common/services/request.js'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    select: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      dialogVisible: false,
      editAddressObj: null,
      selecteAddress: {
        recipientsName: '',
        recipientsPhone: '',
        address: [],
        detailAddress: ''
      },
      addressOptions: [],
      selectedAddressCache: {
        province: null,
        city: null,
        area: null
      }
    }
  },
  methods: {
    async confirmAddress() {
      const { recipientsName, recipientsPhone, address, detailAddress } = this.selecteAddress
      if (!recipientsName || !recipientsPhone || !address || !detailAddress) {
        this.$message.error('请输入完整的邮寄信息')
        return
      }
      if (!/^1[0-9]{10}$/.test(recipientsPhone)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      if (!this.selectedAddressCache.area) {
        this.handleChange(this.selecteAddress.address)
      }
      const params = {}
      params.recipientsName = recipientsName
      params.recipientsPhone = recipientsPhone
      params.detailAddress = detailAddress
      params.province = this.selectedAddressCache.province.label
      params.provinceCode = this.selectedAddressCache.province.value
      params.city = this.selectedAddressCache.city.label
      params.cityCode = this.selectedAddressCache.city.value
      params.area = this.selectedAddressCache.area.label
      params.areaCode = this.selectedAddressCache.area.value
      if (this.editAddressObj) {
        //编辑
        if (this.editAddressObj.id) {
          params.id = this.editAddressObj.id
        } else if (this.editAddressObj._id) {
          params._id = this.editAddressObj._id
        }
        this.$emit('update-info', { type: 'update', payload: params })
      } else {
        //新增
        params._id = this.data.length + 1
        this.$emit('update-info', { type: 'add', payload: params })
      }
      this.dialogVisible = false
    },
    handleInputPhone(val) {
      if (val) {
        const match = val.match(/^\d+$/)
        if (match) {
          this.selecteAddress.recipientsPhone = match[0]
        }
      } else {
        this.selecteAddress.recipientsPhone = ''
      }
    },
    async handleDialogOpen() {
      this.selectedAddressCache.province = null
      this.selectedAddressCache.city = null
      this.selectedAddressCache.area = null
      if (this.addressOptions.length === 0) {
        await this.getProvinces()
      }
      if (this.selecteAddress.address.length === 3) {
        const { address } = this.selecteAddress
        await this.handleExpandChange([address[0]])
        await this.handleExpandChange([address[0], address[1]])
      }
    },
    async editAddress(address) {
      this.editAddressObj = address
      this.selecteAddress.recipientsName = address.recipientsName
      this.selecteAddress.recipientsPhone = address.recipientsPhone
      this.selecteAddress.address = [address.provinceCode, address.cityCode, address.areaCode]
      this.selecteAddress.detailAddress = address.detailAddress
      this.dialogVisible = true
    },
    addAddress() {
      this.editAddressObj = null
      this.selecteAddress.recipientsName = ''
      this.selecteAddress.recipientsPhone = ''
      this.selecteAddress.address = []
      this.selecteAddress.detailAddress = ''
      this.dialogVisible = true
    },
    handleChange(val) {
      if (this.selectedAddressCache.city) {
        const area = this.selectedAddressCache.city.children.find(ele => ele.value === val[2])
        this.selectedAddressCache.area = area
      }
    },
    async handleExpandChange(val) {
      if (val.length === 1) {
        const province = this.addressOptions.find(ele => ele.value === val[0])
        this.selectedAddressCache.province = province
        if (province.children.length === 0) {
          await this.getCities(val[0])
        }
      } else if (val.length === 2) {
        const city = this.selectedAddressCache.province.children.find(ele => ele.value === val[1])
        this.selectedAddressCache.city = city
        if (city.children.length === 0) {
          await this.getAreas(val[1])
        }
      }
    },
    async getProvinces(provinceCode = '') {
      const { success, data } = await this.$get('user.getProvinces', { provinceCode: provinceCode })
      if (success && data[0] && data[0].value && this.addressOptions.length === 0) {
        data[0].value.forEach(ele => {
          this.addressOptions.push({
            id: ele.id,
            value: ele.provinceCode,
            label: ele.provinceName,
            children: []
          })
        })
      }
    },
    async getCities(fatherCode = '110000') {
      const { success, data } = await this.$get('user.getCities', { fatherCode: fatherCode })
      if (success && data[0] && data[0].value) {
        data[0].value.forEach(ele => {
          this.selectedAddressCache.province.children.push({
            id: ele.id,
            value: ele.cityCode,
            label: ele.cityName,
            children: []
          })
        })
      }
    },
    async getAreas(fatherCode = '110100') {
      const { success, data } = await this.$get('user.getAreas', { fatherCode: fatherCode })
      if (success && data[0] && data[0].value) {
        data[0].value.forEach(ele => {
          this.selectedAddressCache.city.children.push({
            id: ele.id,
            value: ele.areaCode,
            label: ele.areaName
          })
        })
      }
    }
  }
}
</script>

<style lang="less">
#choose-apply-address {
  .el-radio__label {
    color: #606266;
    white-space: nowrap;
  }
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.choose-apply-address-dia {
  height: 400px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>

<style lang="less" scoped>
#choose-apply-address {
  .area {
    background: #f8f8f8;
    width: 100%;
    min-width: 980px;
    padding-bottom: 20px;
    &-head {
      height: 50px;
      line-height: 50px;
      padding: 0 25px;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .item {
    height: 40px;
    line-height: 40px;
    margin: 0 25px;
    padding: 0 20px;
    cursor: pointer;
    .radio {
      white-space: nowrap;
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }

    &:hover {
      background: #fff;
    }
  }
}
</style>
